import React, { useEffect, useState } from "react";
import { closeIcon } from "../../assets/icons/SvgIconList";
import { cn } from "../../lib";

interface IICModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  containerClass?: string;
}

const ICModal: React.FC<IICModalProps> = ({
  title,
  onClose,
  children,
  containerClass,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  return (
    <div
      className={cn(
        `fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center bg-black bg-opacity-40 transition-opacity duration-300`,
        { "opacity-100": isVisible, "opacity-0": !isVisible }
      )}
    >
      <div
        className={cn(
          `bg-subtle rounded-lg shadow-lg max-w-lg w-full mx-4 md:mx-0 custom-transform ${containerClass}`,
          { "modal-enter": isVisible, "modal-leave": !isVisible }
        )}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold">{title}</h2>
          <div className="size-5 cursor-pointer">
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              {closeIcon}
            </div>
          </div>
        </div>

        <div className="p-4 max-h-[80vh] overflow-hidden flex flex-col">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ICModal;
